import { render } from "./CopyTest.vue?vue&type=template&id=2ad4c3f7&scoped=true"
import script from "./CopyTest.vue?vue&type=script&lang=js"
export * from "./CopyTest.vue?vue&type=script&lang=js"

import "./CopyTest.vue?vue&type=style&index=0&id=2ad4c3f7&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad4c3f7"]])

export default __exports__